import Api from './Api';

const all = (payload) => {
    const path = '/merged-invoices';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const get = (payload) => {
    return Api.getRequest({
        endpoint: `/merged-invoice/get-by-merged-id/${payload.id}`,
    });
};

const getLiveLinkDetails = (payload) => {
    return Api.getRequest({
        endpoint: `/merged-invoice/live-link-details/${payload.id}`,
    });
};

const updateManualPayment = (payload)=> {
    return Api.postRequest({
        endpoint: '/merged-invoice/update-manual-merged-payment',
        method: 'PUT',
        data: payload
    });
}

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/merged-invoice/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/merged-invoice/update',
        method: 'PUT',
        data: payload
    });
};

const remove = (payload) => {
    return Api.deleteRequest({
        endpoint: `/merged-invoice/delete/${payload.id}`,
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/merged-invoice/destroy/${payload.id}`,
    });
};

const mergedMailHandler = (payload) => {
    return Api.postRequest({
        endpoint: '/merged-invoice/merged-payment-mail',
        data: payload
    });
}

const updateMergedMailHandler = (payload) => {
    return Api.postRequest({
        endpoint: '/merged-invoice/update-merged-mail',
        data: payload
    });
}

export default {
    all,
    get,
    updateManualPayment,
    store,
    update,
    remove,
    destroy,
    mergedMailHandler,
    updateMergedMailHandler,
    getLiveLinkDetails,
}